import { StructError } from 'superstruct';
import { call } from '../../../../stent/call';
import { Cart } from '../../../schema';
export const makeInit = function(ctx) {
    const { fetchCartContents  } = ctx;
    return function* init(machine) {
        try {
            yield {
                name: 'Initializing',
                contents: null,
                error: null
            };
            const rawFetchCartResponse = yield call(fetchCartContents, undefined);
            const [err, contents] = Cart.validate(rawFetchCartResponse, {
                coerce: true
            });
            if (err instanceof StructError) {
                console.error('Cart data can not be parsed', err.failures(), contents);
                throw err;
            }
            if (!contents) {
                console.error('Cart data is invalid', contents);
                throw new Error('Cart data is invalid');
            }
            yield {
                contents,
                name: 'Ready',
                error: null
            };
        } catch (err) {
            yield {
                error: err instanceof Error ? err : new Error('Unknown error [78218467b35c404ab53c58868518bbdf]'),
                name: 'Failure',
                contents: machine.state.contents
            };
        }
    };
};
